import { adminStoreQueries } from "$/lib/queries/admin-store-queries"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/(app)/_auth/")({
  loader: async ({ context: { queryClient } }) => {
    queryClient.prefetchQuery(adminStoreQueries.list())
  },
})
